import type React from 'react';
import { useState } from 'react';
import Dialog from '../../../../../../stories/Molecules/Dialog/Dialog';

export interface DeadLineModalProps {
  productId: number;
  shippingCostsText: string;
  siteUrl: string;
}

const DeadLineModal: React.FC<DeadLineModalProps> = ({
  productId,
  shippingCostsText,
  siteUrl,
}) => {
  const [dialogState, setDialogState] = useState({
    isLoading: false,
    isOpen: false,
  });

  const toggleDialog = (show: boolean) => {
    setDialogState({
      isLoading: show,
      isOpen: show,
    });
  };

  return (
    <>
      <span
        className="pointer"
        onClick={() => toggleDialog(true)}
      >
        {shippingCostsText}
      </span>
      <Dialog
        size="sm"
        onClose={() => toggleDialog(false)}
        open={dialogState.isOpen}
        isLoading={dialogState.isLoading}
        closeButton
      >
        <Dialog.Body>
          <iframe
            data-testid="deadline-iframe"
            className="mt-10"
            style={{ height: '350px' }}
            src={`${siteUrl}deadline/shipping-costs?productId=${productId}`}
            onLoad={() =>
              setDialogState((state) => ({ ...state, isLoading: false }))
            }
          />
        </Dialog.Body>
      </Dialog>
    </>
  );
};

export default DeadLineModal;
